<template>    
    <div class="popup" v-if="opened">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'app-popup',
        props: {
            opened: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="scss">
    .popup {
        @apply .absolute .pin-r .block .bg-white .rounded .shadow-md;

        top: 110%;
    }
</style>


// WEBPACK FOOTER //
// src/components/Popup.vue